const config = {
  pollingFrequency: 5000,
};

export default config;
